export default __webpack_public_path__ + "static/media/los_vengadores_acoso_nunca_mas.413ab9d5.pdf";